import {Component, Input, OnChanges, OnInit} from '@angular/core';
import {PermissionsService} from "../../services/permissions/permissions.service";

@Component({
  selector: 'app-character-limit',
  templateUrl: './character-limit.component.pug',
  styleUrls: ['./character-limit.component.scss'],
  standalone: false
})
export class CharacterLimitComponent implements OnInit {
  @Input() sms?: any;
  @Input() subjectLine?: any;
  @Input() isSms!: boolean;
  @Input() smsLimit?: any;
  @Input() subjectLineLimit?: any;
  smsCount = 0;
  subjectLineCount = 0;

  constructor(
    public permissions: PermissionsService,
  ) {
  }

  ngOnInit(): void {
  }

}
